import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

// Import pages
import LandingPage from "./pages/LandingPage";
import FinderPage from "./pages/FinderPage";
import Dashboard from "./pages/Dashboard";
import AuthPage from "./pages/AuthPage";
import AuthVerify from "./pages/AuthVerify";
import AdminPanel from "./pages/AdminPanel";
import ReplyPage from "./pages/ReplyPage";
import Store from "./pages/Store";
import ProductStore from "./pages/ProductStore";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import Subscription from "./pages/Subscription";
import UseCases from "./pages/UseCases";
import Support from "./pages/Support";
import Help from "./pages/Help";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Compare from "./pages/Compare";

// Context providers
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <div className="App min-h-screen bg-gray-50">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/auth/:token" element={<AuthVerify />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/reply/:messageId" element={<ReplyPage />} />
            <Route path="/store" element={<ProductStore />} />
            <Route path="/shop" element={<ProductStore />} />
            <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/use-cases" element={<UseCases />} />
            <Route path="/support" element={<Support />} />
            <Route path="/help" element={<Help />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/:uid" element={<FinderPage />} />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;